export const searchToObject = () => {
  let pairs = window.location.search.substring(1).split('&'),
    obj = {},
    pair,
    i;

  for (i in pairs) {
    if (pairs[i] === '') continue;

    pair = pairs[i].split('=');
    obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }

  return obj;
};

export const publicUrl = (url) => {
  const {ASSET_URL} = process.env;
  return ASSET_URL && `${ASSET_URL.replace('/assets', '')}${url}`;
};
